import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';

/**
 * Hook to get the count of pending join requests for a group
 * Used to display notification badge on Admin icon
 * 
 * @param groupId - ID of the group to check
 * @returns count of pending requests and loading state
 */
export const usePendingJoinRequestsCount = (groupId: string | undefined, tournamentId?: string) => {
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!groupId || (tournamentId === undefined && !groupId)) {
            setCount(0);
            setLoading(false);
            return;
        }

        let q;
        if (tournamentId) {
            q = query(
                collection(db, 'groups', groupId, 'tournaments', tournamentId, 'joinRequests'),
                where('status', '==', 'pending')
            );
        } else {
            q = query(
                collection(db, 'groups', groupId, 'joinRequests'),
                where('status', '==', 'pending')
            );
        }

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setCount(snapshot.size);
            setLoading(false);
        }, (error) => {
            console.error("Error listening to pending join requests:", error);
            setCount(0);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [groupId, tournamentId]);

    return { count, loading };
};
